import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import headerLogoAfterLoggin from "../../assets/images/Namewhite.svg";
import centterLogoAfterLogin from "../../assets/images/fullwhite.svg";
import centterLogoBeforeLogin from "../../assets/images/fullColore.svg";
import bottumSVGContenAfterLogin from "../../assets/images/m-img.png";
import bottumSVGContenBeforeLogin from "../../assets/images/bottomContent.svg";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {  withTranslation } from "react-i18next";
import { getTabName } from "../../redux/navigatePath/navigateAction";
import Hamburger from "hamburger-react";
// import { CModal, CModalBody, CModalTitle } from "@coreui/react";
// import closeArrow from "../../assets/images/cross.png";
import { getPrivacyAndTerms } from "../../redux/privacyAndTerms/privacyAndTermsAction";
import moment from "moment";
import {
  getNotification,
  updateNotification,
} from "../../redux/notification/notificationAction";
import CommonToaster from "../../utils/Toaster";
import toast from "react-hot-toast";
import { getQuestionariesList } from "../../redux/questionaries/questionariesAction";

// const Data = [];

const Header = ({ t }) => {
  const dispatch = useDispatch();
  // const languege = useSelector((state) => state?.AuthReducer?.lang);
  const selectedTab = useSelector((state) => state?.NavigationReducer);
  const notificationList = useSelector(
    (state) => state?.NotificationReducer?.notification?.data
  );
  const location = useLocation();
  const userDetails = useSelector((state) => state?.UserReducer?.userDetails);
  const navigate = useNavigate();
  let isLogedIn = JSON.parse(localStorage.getItem("isLogedIn"));
  const { formIntroId, id } = useParams();
  const [formName, setformName] = useState("");
  const [toggleValue, settoggleValue] = useState(false);
  const [pathForURL, setPathForURL] = useState({});

  const formDetails = useSelector(
    (state) => state?.QuestionariesReducer?.formDetails
  );
  // const PrivacyAndTermsData = useSelector(
  //   (state) => state?.PrivacyAndTermsReducer
  // );
  // const [visible, setVisible] = useState({ terms: false, privacy: false });
  const questionariesList = useSelector(
    (state) => state?.QuestionariesReducer?.questionsFormDataList
  );
  const questionDataList = useSelector(
    (state) => state?.QuestionariesReducer?.questionariesList?.data
  );
  const [isOpen, setOpen] = useState(false);
  useEffect(() => {
    if (questionariesList?.data?.length !== 0) {
      if (formIntroId && formDetails) {
        setformName(formDetails?.title);
      } else {
        const formNameValue = questionariesList?.data?.find(
          (item) => item?.formId === id || item?.formId === formIntroId
        );
        setformName(formNameValue?.formTitle);
      }
    }
  }, [questionariesList, id, formDetails, formIntroId]);

  // useEffect(() => {
  //   i18n.changeLanguage(languege);
  // }, [languege, i18n]);

  useEffect(() => {
    dispatch(getPrivacyAndTerms());
  }, [dispatch]);

  useEffect(() => {
    if (isLogedIn) {
      dispatch(getQuestionariesList({ pageNo: 0, limit: 10 }));
      dispatch(getNotification());
    }
  }, [dispatch, isLogedIn]);
  // lOG OUT HANDLER
  const handleLogout = () => {
    if (isLogedIn) {
      localStorage.setItem("isLogedIn", false);
      localStorage.clear();
      navigate("/auth");
    } else {
      navigate("/auth/signIn");
      setOpen(false);
    }
  };

  // const changeLanguage = (lang) => {
  //   localStorage.setItem("lang", lang);
  //   dispatch(changeLang(lang));
  //   i18n.changeLanguage(lang);
  // };

  const handleTab = (tabValue) => {
    localStorage.setItem("tab", tabValue);
    dispatch(getTabName({ tabName: tabValue, tabAction: "" }));
    setOpen(false);
  };
  const toggleNotification = () => {
    dispatch(updateNotification());
    settoggleValue(!toggleValue);
  };
  // const nl2br = (string) => {
  //   if (string) {
  //     return string.split("\n").map((item, key) => {
  //       return (
  //         <span key={key}>
  //           {item}
  //           <br />
  //         </span>
  //       );
  //     });
  //   }
  // };

  // const handleVisibleModel = (e, value) => {
  //   e.preventDefault();
  //   if (value === "terms") {
  //     setVisible({ ...visible, terms: true });
  //   } else {
  //     setVisible({ ...visible, privacy: true });
  //   }
  // };
  useEffect(() => {
    if (location.pathname === "/info/projects") {
      setPathForURL({
        urlPath: "/info/projects",
        pathName: "Il progetto",
      });
    } else if (location.pathname === "/questions-list") {
      setPathForURL({
        urlPath: "/questions-list",
        pathName: "I tuoi questionari",
      });
    } else if (location.pathname === "/user-details") {
      setPathForURL({
        urlPath: "/user-details",
        pathName: "I tuoi dati",
      });
    } else if (location.pathname === "/info/FAQ") {
      setPathForURL({
        urlPath: "/info/FAQ",
        pathName: "FAQ",
      });
    } else if (location.pathname === "/info/contact") {
      setPathForURL({
        urlPath: "/info/contact",
        pathName: "Contatti",
      });
    } else {
      setPathForURL({
        urlPath: "/questions-list",
        pathName: "I tuoi questionari",
      });
    }
  }, [location]);

  return (
    <>
      <header
        className={!isLogedIn ? "header-light light-header" : "header-blue"}
      >
        <div className="container-fluid">
          <div className={`main-header ${!isLogedIn ? "dark-navname" : ""}`}>
            <div className="logo">
              <a href="/" onClick={(e) => e.preventDefault()}>
                <img
                  src={
                    !isLogedIn ? centterLogoBeforeLogin : headerLogoAfterLoggin
                  }
                  alt="logo"
                />
              </a>
            </div>
            {/*** 
            {isLogedIn ? (
              <div
                className="notifaction mobile main-notifaction"
                id="notificationLink"
                onClick={toggleNotification}
              >
                {notificationList &&
                notificationList.some((ele) => ele.isRead === false) ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                  >
                    <rect width="40" height="40" rx="4" fill="#435E9B" />
                    <path
                      d="M10.132 27.1343L8.54433 25.9179H8.54433L10.132 27.1343ZM11.5857 23.0472L9.58584 23.0225L9.58569 23.0348V23.0472H11.5857ZM11.6162 20.5761L13.6161 20.6008L13.6162 20.5884V20.5761H11.6162ZM29.8758 27.1541L31.4876 25.97L31.4876 25.97L29.8758 27.1541ZM28.4768 23.0472L26.4769 23.0212L26.4768 23.0342V23.0472H28.4768ZM28.5073 20.6985L30.5071 20.7245L30.5073 20.7115V20.6985H28.5073ZM11.7196 28.3506C12.6381 27.1517 13.5857 25.3187 13.5857 23.0472H9.58569C9.58569 24.1864 9.10533 25.1857 8.54433 25.9179L11.7196 28.3506ZM13.5855 23.0719L13.6161 20.6008L9.61635 20.5514L9.58584 23.0225L13.5855 23.0719ZM31.4876 25.97C30.9517 25.2405 30.4768 24.2225 30.4768 23.0472H26.4768C26.4768 25.3059 27.3806 27.1357 28.264 28.3382L31.4876 25.97ZM30.4766 23.0732L30.5071 20.7245L26.5075 20.6726L26.4769 23.0212L30.4766 23.0732ZM30.5073 20.6985C30.5073 14.9193 25.787 10.2632 20 10.2632V14.2632C23.6099 14.2632 26.5073 17.1604 26.5073 20.6985H30.5073ZM29.3667 30.2993C30.6627 30.2993 31.4582 29.3964 31.7691 28.6721C32.0773 27.9543 32.1583 26.8829 31.4876 25.97L28.264 28.3382C27.8998 27.8424 27.9864 27.3436 28.0935 27.0941C28.2034 26.8382 28.5911 26.2993 29.3667 26.2993V30.2993ZM13.6162 20.5761C13.6162 17.1055 16.4583 14.2632 20 14.2632V10.2632C14.2812 10.2632 9.6162 14.8645 9.6162 20.5761H13.6162ZM10.6345 26.2993C11.4261 26.2993 11.8093 26.8564 11.9124 27.1041C12.0133 27.3464 12.1014 27.8522 11.7196 28.3506L8.54433 25.9179C7.84377 26.8324 7.91958 27.9207 8.21972 28.6416C8.52208 29.3678 9.31593 30.2993 10.6345 30.2993V26.2993ZM29.3667 26.2993H10.6345V30.2993H29.3667V26.2993ZM22 28.2993C22 29.095 21.2539 30 20 30V34C23.1644 34 26 31.5913 26 28.2993H22ZM20 30C18.7461 30 18 29.095 18 28.2993H14C14 31.5913 16.8356 34 20 34V30ZM20.6667 9.63158C20.6667 9.9555 20.3932 10.2632 20 10.2632V14.2632C22.5523 14.2632 24.6667 12.2144 24.6667 9.63158H20.6667ZM20 10.2632C19.6068 10.2632 19.3333 9.9555 19.3333 9.63158H15.3333C15.3333 12.2144 17.4477 14.2632 20 14.2632V10.2632ZM19.3333 9.63158C19.3333 9.30766 19.6068 9 20 9V5C17.4477 5 15.3333 7.04874 15.3333 9.63158H19.3333ZM20 9C20.3932 9 20.6667 9.30766 20.6667 9.63158H24.6667C24.6667 7.04874 22.5523 5 20 5V9Z"
                      fill="white"
                    />
                    <circle cx="31.5" cy="9.5" r="4.5" fill="white" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                  >
                    <rect width="40" height="40" rx="4" fill="#435E9B" />
                    <path
                      d="M10.132 27.1343L8.54433 25.9179H8.54433L10.132 27.1343ZM11.5857 23.0472L9.58584 23.0225L9.58569 23.0348V23.0472H11.5857ZM11.6162 20.5761L13.6161 20.6008L13.6162 20.5884V20.5761H11.6162ZM29.8758 27.1541L31.4876 25.97L31.4876 25.97L29.8758 27.1541ZM28.4768 23.0472L26.4769 23.0212L26.4768 23.0342V23.0472H28.4768ZM28.5073 20.6985L30.5071 20.7245L30.5073 20.7115V20.6985H28.5073ZM11.7196 28.3506C12.6381 27.1517 13.5857 25.3187 13.5857 23.0472H9.58569C9.58569 24.1864 9.10533 25.1857 8.54433 25.9179L11.7196 28.3506ZM13.5855 23.0719L13.6161 20.6008L9.61635 20.5514L9.58584 23.0225L13.5855 23.0719ZM31.4876 25.97C30.9517 25.2405 30.4768 24.2225 30.4768 23.0472H26.4768C26.4768 25.3059 27.3806 27.1357 28.264 28.3382L31.4876 25.97ZM30.4766 23.0732L30.5071 20.7245L26.5075 20.6726L26.4769 23.0212L30.4766 23.0732ZM30.5073 20.6985C30.5073 14.9193 25.787 10.2632 20 10.2632V14.2632C23.6099 14.2632 26.5073 17.1604 26.5073 20.6985H30.5073ZM29.3667 30.2993C30.6627 30.2993 31.4582 29.3964 31.7691 28.6721C32.0773 27.9543 32.1583 26.8829 31.4876 25.97L28.264 28.3382C27.8998 27.8424 27.9864 27.3436 28.0935 27.0941C28.2034 26.8382 28.5911 26.2993 29.3667 26.2993V30.2993ZM13.6162 20.5761C13.6162 17.1055 16.4583 14.2632 20 14.2632V10.2632C14.2812 10.2632 9.6162 14.8645 9.6162 20.5761H13.6162ZM10.6345 26.2993C11.4261 26.2993 11.8093 26.8564 11.9124 27.1041C12.0133 27.3464 12.1014 27.8522 11.7196 28.3506L8.54433 25.9179C7.84377 26.8324 7.91958 27.9207 8.21972 28.6416C8.52208 29.3678 9.31593 30.2993 10.6345 30.2993V26.2993ZM29.3667 26.2993H10.6345V30.2993H29.3667V26.2993ZM22 28.2993C22 29.095 21.2539 30 20 30V34C23.1644 34 26 31.5913 26 28.2993H22ZM20 30C18.7461 30 18 29.095 18 28.2993H14C14 31.5913 16.8356 34 20 34V30ZM20.6667 9.63158C20.6667 9.9555 20.3932 10.2632 20 10.2632V14.2632C22.5523 14.2632 24.6667 12.2144 24.6667 9.63158H20.6667ZM20 10.2632C19.6068 10.2632 19.3333 9.9555 19.3333 9.63158H15.3333C15.3333 12.2144 17.4477 14.2632 20 14.2632V10.2632ZM19.3333 9.63158C19.3333 9.30766 19.6068 9 20 9V5C17.4477 5 15.3333 7.04874 15.3333 9.63158H19.3333ZM20 9C20.3932 9 20.6667 9.30766 20.6667 9.63158H24.6667C24.6667 7.04874 22.5523 5 20 5V9Z"
                      fill="white"
                    />
                  </svg>
                )}
              </div>
            ) : null}
          ***/}

            <div
              id="notificationContainer"
              className={`notificationContainer ${
                !toggleValue ? "display-none" : "display-block"
              }`}
            >
              <div id="notificationTitle">
                Notifications{" "}
                <span onClick={toggleNotification}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                  >
                    <path
                      d="M28 12L12 28M28 28L12 12"
                      stroke="#435E9B"
                      strokeWidth="4"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
              </div>
              <div id="notificationsBody" className="notifications">
                {notificationList &&
                  notificationList?.map((ele) => (
                    <div className="notifaction-box">
                      <h5>{moment(ele?.createdAt).format("DD-MM-YYYY")}</h5>
                      <h4>{ele?.title}</h4>
                      <h6>{ele?.description}</h6>
                      <div className="btn-section text-center notifaction-btn">
                        {questionDataList &&
                          questionDataList?.map((questions) =>
                            questions.sectionNo !== 0 &&
                            questions._id === ele.formId ? (
                              <button
                                href="#"
                                className="solid-btn bg-color"
                                onClick={() => {
                                  if (
                                    moment(userDetails?.pregenancyDate)
                                      .add(questions?.timeline, "M")
                                      .toISOString() > moment().toISOString()
                                  ) {
                                    const toastId = toast.loading(
                                      t("Attendere prego")
                                    );
                                    CommonToaster({
                                      toastId,
                                      toastType: "error",
                                      message: t("Bloccato."),
                                    });
                                  } else if (
                                    moment(userDetails?.pregenancyDate)
                                      .add(
                                        questions?.timeline +
                                          questions?.expireTime,
                                        "M"
                                      )
                                      .toISOString() < moment().toISOString()
                                  ) {
                                    const toastId = toast.loading(
                                      t("Attendere prego")
                                    );
                                    CommonToaster({
                                      toastId,
                                      toastType: "error",
                                      message: t("Questo modulo è scaduto"),
                                    });
                                  } else if (
                                    moment(userDetails?.pregenancyDate)
                                      .add(
                                        questions?.timeline +
                                          questions?.expireTime,
                                        "M"
                                      )
                                      .toISOString() >=
                                      moment().toISOString() &&
                                    questions?.CompletedSectionCount === 0
                                  ) {
                                    navigate(`/form-intro/${questions?._id}`, {
                                      state: {
                                        id: questions?._id,
                                      },
                                    });
                                  } else if (
                                    questions?.sectionNo ===
                                    questions?.CompletedSectionCount
                                  ) {
                                    const toastId = toast.loading(
                                      t("Attendere prego")
                                    );
                                    CommonToaster({
                                      toastId,
                                      toastType: "success",
                                      message: t("Il modulo è già compilato."),
                                    });
                                  } else if (
                                    questions?.sectionNo !==
                                    questions?.CompletedSectionCount
                                  ) {
                                    navigate(`/form-intro/${questions?._id}`, {
                                      state: {
                                        id: questions?._id,
                                      },
                                    });
                                    toggleNotification();
                                  }
                                }}
                              >
                                Compila
                              </button>
                            ) : null
                          )}
                      </div>
                    </div>
                  ))}
              </div>
              {/* <!-- <div id="notificationFooter"><a href="#">See All</a></div> --> */}
            </div>

            <Hamburger
              color={!isLogedIn ? "#435E9B" : "white"}
              toggled={isOpen}
              toggle={setOpen}
            />
            <ul
              className={`nav-links ${
                !isLogedIn ? "color-white" : "color-black"
              }`}
              style={{
                display: `${isOpen ? "block" : "none"}`,
                clipPath: "circle(100% at center)",
              }}
            >
              <li className="mobile m-logo">
                <a href="/" onClick={(e) => e.preventDefault()}>
                  <img
                    src={
                      isLogedIn ? centterLogoAfterLogin : centterLogoBeforeLogin
                    }
                    className="mobile"
                    alt="logo"
                  />
                </a>
              </li>
              <>
                <li
                  className={`nav-link ${isOpen ? "opacityFixed" : ""}`}
                  onClick={() => handleTab("Il progetto")}
                >
                  <Link
                    to={"/info/projects"}
                    className={
                      location.pathname === "/info/projects"
                        ? "active-link"
                        : ""
                    }
                  >
                    {t("Il progetto")}
                  </Link>
                </li>
                {isLogedIn === true ? (
                  <>
                    <li
                      className={`nav-link ${isOpen ? "opacityFixed" : ""}`}
                      onClick={() => handleTab("tuoi questionari")}
                    >
                      <Link
                        to={"/questions-list"}
                        className={
                          location.pathname === "/questions-list"
                            ? "active-link"
                            : ""
                        }
                      >
                        {t("I tuoi questionari")}
                      </Link>
                    </li>
                    <li
                      className={`nav-link ${isOpen ? "opacityFixed" : ""}`}
                      onClick={() => handleTab("tuoi dati")}
                    >
                      <Link
                        to={"/user-details"}
                        className={
                          location.pathname === "/user-details"
                            ? "active-link"
                            : ""
                        }
                      >
                        {t("I tuoi dati")}
                      </Link>
                    </li>
                  </>
                ) : null}
                <li
                  className={`nav-link ${isOpen ? "opacityFixed" : ""}`}
                  onClick={() => handleTab("FAQ")}
                >
                  <Link
                    to={"/info/FAQ"}
                    className={
                      location.pathname === "/info/FAQ" ? "active-link" : ""
                    }
                  >
                    {t("FAQ")}
                  </Link>
                </li>
                <li
                  className={`nav-link ${isOpen ? "opacityFixed" : ""}`}
                  onClick={() => handleTab("Contatti")}
                >
                  <Link
                    to={"/info/contact"}
                    className={
                      location.pathname === "/info/contact" ? "active-link" : ""
                    }
                  >
                    {t("Contatti")}
                  </Link>
                </li>
               {/* <ul
                  className={`page-breadcrumb language-selection d-flex justify-content-center ${
                    !isLogedIn ? "additional-language-selection" : ""
                  }`}
                >
                  <li>
                    <span
                      style={{
                        color: "white",
                        paddingRight: "8px",
                        fontSize: "30px",
                      }}
                      onClick={() =>
                        changeLanguage(languege === "it" ? "en" : "it")
                      }
                    >
                      <span></span> {languege === "it" ? "ENG" : "ITA"}
                    </span>
                  </li>
                </ul>*/}
                <>
                  {/* <li className={`nav-link ${isOpen ? "opacityFixed" : ""}`}>
                      <button className="icons-btn desktop">
                        <i className="ri-notification-2-line" />
                      </button>
                      <button
                        className="icons-btn desktop"
                        onClick={handleLogout}
                      >
                        <i className="ri-logout-box-line"></i>
                      </button>
                    </li> */}

                  <li
                    className={`nav-link ${isLogedIn ? "signUpBtn" : ""} ${
                      isOpen ? "opacityFixed" : ""
                    }`}
                  >
                    <div className="text-center mt-50 mb-50  logout-btn">
                      <button className="solid-btn" onClick={handleLogout}>
                        {isLogedIn ? "Log Out" : t("Accedi")}
                      </button>
                    </div>
                  </li>
                </>
                <li className={`nav-link ${isOpen ? "opacityFixed" : ""}`}>
                  <div className="text-center mt-50 mb-50 mobile">
                    <img
                      src={
                        isLogedIn
                          ? bottumSVGContenAfterLogin
                          : bottumSVGContenBeforeLogin
                      }
                      alt="m-img"
                      className="img-fluid"
                    />
                  </div>
                </li>

                {/* <li className="nav-link information-privacy mobile">
                  <a
                    href="/"
                    onClick={(e) => {
                      handleVisibleModel(e, "privacy");
                    }}
                  >
                    {t("Informativa Privacy")}
                    <br />
                  </a>
                  <a
                    href="/"
                    onClick={(e) => {
                      handleVisibleModel(e, "terms");
                    }}
                  >
                    <br />
                    {t("e trattamento dei dati")}
                  </a>
                </li> */}
              </>
            </ul>
          </div>
        </div>
      </header>
      {isLogedIn === true && selectedTab?.tabName ? (
        <div className="bottom-header">
          <div className="container-fluid">
            <ul className="page-breadcrumb">
              {isLogedIn === true ? (
                <>
                  <li className="d-flex">
                    <Link to={selectedTab?.tabAction}>
                      {selectedTab?.tabAction === "/user-details" ? (
                        <Link to={"/user-details"}>
                          {t(pathForURL.pathName)}
                        </Link>
                      ) : (
                        t(pathForURL.pathName)
                      )}
                    </Link>
                    {formName || selectedTab?.tabName?.split(">")[1] ? (
                      <span style={{ color: "#fff" }}>{">"}</span>
                    ) : null}
                  </li>
                  <li className="questionName">
                    {selectedTab?.tabAction === "/user-details" ? (
                      <Link>{selectedTab?.tabName?.split(">")[1]}</Link>
                    ) : (
                      <Link>{formName}</Link>
                    )}
                  </li>
                </>
              ) : null}
            </ul>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default withTranslation()(Header);
